import { ITask } from "./Models/ITask";
import { SubscribableCollectionWithBackingStore } from "./SubscribableWithBackingStore";

export class TaskSubscribable extends SubscribableCollectionWithBackingStore<ITask> {}
